module.exports = "<section class=section-content> <fragment v-if=currentFragment :fragment.sync=currentFragment></fragment> <div class=backdrop :class={active:this.focusIds.length} @click.prevent.stop=unfocus></div> </section>";


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Edit.vue
 ** module id = 131
 ** module chunks = 0
 **/